import { AdacSelect } from '@adac-de/component-library';
import React from 'react';

type SelectOption = {
  label: string;
  value: string;
};

type SelectProps = {
  id: string;
  defaultValue?: string;
  selectValue?: string;
  handleOnChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  defaultOptionText: string;
  options: SelectOption[];
  ariaLabel: string;
} & React.HtmlHTMLAttributes<HTMLSelectElement>;

export const Select: React.FC<SelectProps> = ({
  id,
  defaultValue = '',
  selectValue,
  handleOnChange,
  defaultOptionText,
  options,
  ariaLabel,
  ...rest
}) => (
  <AdacSelect
    id={id}
    defaultValue={selectValue ? undefined : defaultValue}
    value={selectValue}
    onChange={handleOnChange}
    aria-describedby={ariaLabel}
    {...rest}
  >
    <option disabled value="">
      {defaultOptionText}
    </option>
    {options.map(({ label, value }) => (
      <option key={label} value={value}>
        {label}
      </option>
    ))}
  </AdacSelect>
);
